import { render, staticRenderFns } from "./BaseImgIcon.vue?vue&type=template&id=5df2bab2"
import script from "./BaseImgIcon.vue?vue&type=script&lang=js"
export * from "./BaseImgIcon.vue?vue&type=script&lang=js"
import style0 from "./BaseImgIcon.vue?vue&type=style&index=0&id=5df2bab2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports